exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, " {\n}\n", ""]);

// Exports
exports.locals = {
	"color-labs-red": "#a0372d",
	"color-darkest-grey": "#282828",
	"color-dark-grey": "#4a4a4a",
	"color-mid-grey": "#696969",
	"color-light-grey": "#767676",
	"color-lightest-grey": "#f2f2f2",
	"color-subt-green": "#69e3c2",
	"color-light-shilo": "#E2A9A2"
};